var map = {
	"./alcochete.png": 148,
	"./almada.png": 149,
	"./barreiro.png": 150,
	"./canceled.png": 151,
	"./moita.png": 152,
	"./montijo.png": 153,
	"./palmela.png": 154,
	"./seixal.png": 155,
	"./sesimbra.png": 156,
	"./setubal.png": 157,
	"./suspended.png": 158
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 174;



//////////////////
// WEBPACK FOOTER
// ./src/pontospap/icons .*
// module id = 174
// module chunks = 0